import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { setPageTitle } from 'actions/header';
import { logActivity } from 'actions/logs';
import MyAssignments from 'containers/Overview/Sections/MyAssignments';
import moment from 'moment';
import React, { Component } from 'react';
import { translate } from '@haldor/ui';
import { connect } from 'react-redux';

var Tasks = /*#__PURE__*/function (_Component) {
  _inherits(Tasks, _Component);

  var _super = _createSuper(Tasks);

  function Tasks(props) {
    var _this;

    _classCallCheck(this, Tasks);

    _this = _super.call(this, props);
    _this.state = {
      allowed: true
    };
    return _this;
  }

  _createClass(Tasks, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      //log the activity of loading the page
      var logJson = {
        LogType: "Route Change",
        ReferenceType: "Assignments Page",
        Comment: "User loaded page"
      };
      this.props.logActivity(logJson);

      if (this.isIframe() && (window.location.pathname == '/assignments' || window.location.pathname == '/assignments-tab')) {
        var isAllowed = this.props.tenant.tenantServices.find(function (service) {
          return (service.serviceId == 'HALDOR_ASSIGNMENTS' || service.serviceId == 'MS_ASSIGNMENTS') && moment(service.serviceEnd).isSameOrAfter(moment(), 'day');
        });
        this.setState({
          allowed: isAllowed != null
        });
      }

      if (this.isIframe() && window.location.pathname == '/haldor-tab/assignments') {
        this.props.setPageTitle(this.props.translate('tasks-header-overview'));
      }
    }
  }, {
    key: "isIframe",
    value: function isIframe() {
      try {
        return window.self !== window.top;
      } catch (e) {
        return true;
      }
    }
  }, {
    key: "render",
    value: function render() {
      var groupid = this.props.match.params.groupid;

      if (!this.state.allowed) {
        return /*#__PURE__*/React.createElement("div", {
          style: {
            width: '80%',
            maxWidth: '625px',
            margin: '0 auto',
            textAlign: 'center'
          }
        }, this.props.translate('service-not-active-error'));
      }

      if (groupid) {
        return /*#__PURE__*/React.createElement("div", {
          className: "overview"
        }, /*#__PURE__*/React.createElement(MyAssignments, {
          overview: false,
          groupid: groupid
        }));
      }

      return /*#__PURE__*/React.createElement("div", {
        className: "overview"
      }, /*#__PURE__*/React.createElement(MyAssignments, {
        overview: false,
        disableTitle: window.location.pathname == '/haldor-tab/assignments'
      }));
    }
  }]);

  return Tasks;
}(Component);

function mapStateToProps(state) {
  return {
    translate: translate(state.Languages.translations),
    tenant: state.user.tenant,
    groups: state.sections.educationGroups
  };
}

export default connect(mapStateToProps, {
  logActivity: logActivity,
  setPageTitle: setPageTitle
})(Tasks);